/**
 * 动画缓动函数枚举
 */
export const EasingType = {
  LINEAR: 'linear',
  EASE_IN: 'ease-in',
  EASE_OUT: 'ease-out',
  EASE_IN_OUT: 'ease-in-out',
  EASE_IN_QUAD: 'ease-in-quad',
  EASE_OUT_QUAD: 'ease-out-quad',
  EASE_IN_OUT_QUAD: 'ease-in-out-quad',
  EASE_IN_CUBIC: 'ease-in-cubic',
  EASE_OUT_CUBIC: 'ease-out-cubic',
  EASE_IN_OUT_CUBIC: 'ease-in-out-cubic',
};

/**
 * 元素类型枚举
 */
export const ElementType = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  RECT: 'rect',
  CIRCLE: 'circle',
  PATH: 'path',
  SVG: 'svg',
  JSON: 'json',
  SPRITE: 'sprite',
  SPINE: 'spine',
  TRANSITION: 'transition',
  AUDIO: 'audio',
  OSCILLOSCOPE: 'oscilloscope',
  HTML: 'html',
};

/**
 * 图层类型枚举
 */
export const LayerType = {
  ELEMENT: 'element',
  BACKGROUND: 'background',
  OVERLAY: 'overlay',
};

/**
 * 动画类型枚举
 */
export const AnimationType = {
  KEYFRAME: 'keyframe',
  TRANSFORM: 'transform',
};

/**
 * 渲染质量枚举
 */
export const RenderQuality = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  ULTRA: 'ultra',
};

/**
 * 视频导出格式枚举
 */
export const ExportFormat = {
  MP4: 'mp4',
  WEBM: 'webm',
  GIF: 'gif',
};

